import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input } from '../../ui';
import { FormError } from '../auth/AuthLayout';
import { useCaptcha } from '../auth/Turnstile';

/** Name + Turnstile for a guest without an account (spec §9.1). */
export function GuestEntry({ onSubmit, siteKey }: { onSubmit: (name: string, captchaToken?: string) => Promise<void>; siteKey?: string }) {
  const { t } = useTranslation();
  const captcha = useCaptcha(siteKey);
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    const n = name.trim();
    if (n.length < 1 || n.length > 80) return setError(t('guest.nameRequired'));
    setError(null);
    setBusy(true);
    try {
      await onSubmit(n, captcha.token);
    } catch {
      setError(t('guest.error'));
      captcha.reset();
      setBusy(false);
    }
  };

  return (
    <form className="flex flex-col gap-4" onSubmit={submit} noValidate>
      <div className="flex flex-col gap-1">
        <label className="flex flex-col gap-1 font-sans text-sm font-medium text-fg">
          {t('guest.nameLabel')}
          <Input value={name} maxLength={80} autoComplete="name" aria-describedby="guest-name-hint" onChange={(e) => setName(e.target.value)} />
        </label>
        <span id="guest-name-hint" className="font-sans text-xs text-fg-muted">
          {t('guest.nameHint')}
        </span>
      </div>
      {captcha.widget}
      <FormError message={error} />
      <Button variant="primary" type="submit" disabled={busy || !captcha.ready}>
        {t('guest.continue')}
      </Button>
    </form>
  );
}
